<template>
  <div class="backlogPage">
    <el-container>
      <el-header style="height: 52px; position: relative">
        <el-image
          style="
            width: 100%;
            height: 52px;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 1;
          "
          src="https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/11/顶部@2x-110454966.png"
        ></el-image>
        <div class="between header">
          <el-image
            style="width: 16px; height: 16px; cursor: pointer"
            src="https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/11/返回@2x-111941849.png"
            @click="goBack"
          ></el-image>

          <Photo></Photo>
        </div>
      </el-header>
      <el-container>
        <el-aside
          width="200px"
          style="background: #fff; padding-top: 20px"
          v-if="!isCollapse"
        >
          <div class="flex" style="flex-direction: column">
            <div
              v-for="item in type"
              :key="item.value"
              class="type"
              :class="{ active: item.value === isActive }"
              @click="changType(item.value)"
            >
              {{ item.name }}
            </div>
          </div>
        </el-aside>
        <el-main
          style="height: calc(100vh - 52px); position: relative"
          v-loading="loading"
        >
          <div
            @click="isCollapse = !isCollapse"
            style="
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
              z-index: 10;
              cursor: pointer;
              left: -2px;
              width: 10px;
              height: 40px;
              background: #e0e3e9;
              border-radius: 0 3px 3px 0;
            "
            class="center"
          >
            <i
              :class="isCollapse ? 'el-icon-caret-right' : 'el-icon-caret-left'"
              style="font-size: 10px"
            ></i>
          </div>
          <div
            style="
              color: #1f1f1f;
              font-size: 24px;
              line-height: 32px;
              font-weight: 500;
            "
            class="flex"
          >
            <div class="flex">
              {{ type.find((f) => f.value === isActive).name
              }}<span style="font-size: 20px">({{ total }})</span>
            </div>
            <div
              class="center"
              style="margin-left: 10px; cursor: pointer"
              @click="getAllTodeData"
            >
              <el-image
                style="width: 20px; height: 20px"
                src="https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/10/刷新@2x-165310124.png"
              ></el-image>
              <span style="color: #333333; font-size: 16px">刷新</span>
            </div>
          </div>

          <div style="overflow: auto; margin-top: 19px">
            <div
              style="
                gap: 20px;
                width: fit-content;
                padding-bottom: 2px;
                padding-top: 2px;
              "
              class="flex"
            >
              <div
                v-for="(item, index) in todoNum"
                :key="index"
                class="todoNum"
                @click="setTodeData(item.formId)"
              >
                <div style="font-size: 18px; line-height: 26px">
                  {{ item.formName }}
                </div>
                <div
                  style="
                    margin-top: 6px;
                    color: #1677ff;
                    font-weight: 700;
                    font-size: 26px;
                  "
                >
                  {{ item.num }}
                </div>
              </div>
            </div>
          </div>

          <div
            style="
              margin-top: 18px;
              padding-right: 20px;
              height: calc(100% - 186px);
            "
          >
            <div
              style="
                background: #ffffff;
                border: 1px solid #e8eaf0;
                border-radius: 6px 6px 6px 6px;
                width: 100%;
                height: 100%;
                flex-direction: column;
              "
              class="between"
            >
              <div style="width: 100%">
                <div
                  style="height: 89px; padding: 0 20px; align-items: center"
                  class="flex"
                >
                  <el-form ref="form" :model="form">
                    <el-form class="filter-form" :inline="true">
                      <el-form-item label="菜单名称">
                        <el-select
                          v-model="form.formId"
                          placeholder="筛选菜单名称"
                          clearable
                          style="width: 228px; height: 34px"
                          @change="filterData"
                        >
                          <el-option
                            v-for="item in todoNum"
                            :key="item.formId"
                            :label="`${item.formName} ( ${item.num})`"
                            :value="item.formId"
                          />
                        </el-select>
                      </el-form-item>
                      <el-form-item label="数据标题">
                        <el-input
                          v-model="form.content"
                          placeholder="筛选数据标题"
                          clearable
                          style="width: 228px"
                          @change="filterData"
                        />
                      </el-form-item>
                      <el-form-item
                        :label="isActive === 'myTodo' ? '发起时间' : '接收时间'"
                      >
                        <el-date-picker
                          v-model="form.created"
                          type="daterange"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          @change="filterData"
                        />
                      </el-form-item>
                    </el-form>
                  </el-form>
                </div>
              </div>
              <el-table
                :data="list"
                style="width: 100%"
                border
                :header-cell-style="{ background: '#F6F7F9' }"
                height="100%"
                @sort-change="sortChange"
              >
                <el-table-column
                  type="index"
                  :index="index"
                  width="72"
                  align="center"
                  label="序号"
                ></el-table-column>
                <el-table-column prop="content" label="数据标题" width="auto">
                  <template #default="{ row }">
                    <span class="data-link" @click="handleJoin(row)">{{
                      row.content
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="formName" label="菜单名称" width="auto">
                </el-table-column>
                <el-table-column
                  prop="created"
                  :label="isActive === 'myTodo' ? '发起时间' : '接收时间'"
                  width="auto"
                  sortable="custom"
                >
                </el-table-column>
              </el-table>

              <div
                style="
                  padding: 5px;
                  width: 100%;
                  display: flex;
                  justify-content: flex-end;
                  align-items: center;
                "
              >
                <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :page-sizes="[10, 20, 50, 100]"
                  :page-size="10"
                  layout="total, sizes, prev, pager, next"
                  :total="total"
                >
                </el-pagination>
              </div>
            </div>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>
<script>
import {
  getTodoNum,
  getTodoData,
  getTodoMyData,
  getTodoMyHandledData,
} from "@/api/setProcess";
import Photo from "@/components/Photo.vue";
export default {
  name: "Backlog",
  components: { Photo },
  data() {
    return {
      isCollapse: false,
      condition: "",
      allStatus: "",
      sort: "",
      myJoin: "",
      isActive: "todo",
      todoNum: [],
      list: [],
      total: 0,
      formOption: [],
      formOptionInfo: {},
      approve: {},
      loading: false,
      form: {
        pageNo: 1,
        pageSize: 10,
      },
      type: [
        {
          name: "全部待办",
          value: "todo",
        },
        {
          name: "我的待阅",
          value: "myJoin",
        },
        {
          name: "我发起的",
          value: "myTodo",
        },
        {
          name: "已处理",
          value: "handledTodo",
        },
      ],
    };
  },
  computed: {
    refresh() {
      return this.$store.state.formData.refresh;
    },
  },
  watch: {
    refresh(val) {
      if (val) {
        this.todoNumFn();
        this.getAllTodeData();
      }
    },
  },
  created() {
    const type = this.$route.query.type;
    if (type) {
      this.isActive = type;
    }

    this.todoNumFn();
    this.getAllTodeData();
  },
  methods: {
    changType(type) {
      this.isActive = type;
      this.getAllTodeData();
    },
    sortChange(data) {
      if (data.prop === "created") {
        this.form.sort = data.order === "ascending" ? 2 : 1;
        this.getAllTodeData();
      }
    },
    handleSizeChange(val) {
      this.form.pageSize = val;
      this.getAllTodeData();
    },
    handleCurrentChange(val) {
      this.form.pageNo = val;
      this.getAllTodeData();
    },
    index(index) {
      return index + 1;
    },
    filterData() {
      this.getAllTodeData();
    },
    async handleJoin(item) {
      let result = await this.$store.dispatch("formData/getDetailData", {
        formId: item.formId,
        id: item.dataId,
        type: "see",
      });
      this.$store.commit("formData/setPageNameList", result);
    },
    setTodeData(id) {
      this.form.formId = id;
      this.getAllTodeData();
    },
    async getAllTodeData() {
      this.loading = true;
      if (this.form.created) {
        this.form.createdStart = this.form.created[0];
        this.form.createdEnd = this.form.created[1];
      } else {
        delete this.form.createdStart;
        delete this.form.createdEnd;
      }
      let res;
      if (this.isActive === "todo" || this.isActive === "myJoin") {
        res = await getTodoData(this.form);
      } else if (this.isActive === "myTodo") {
        res = await getTodoMyData(this.form);
      } else {
        res = await getTodoMyHandledData(this.form);
      }
      this.total = res.total;
      this.list = res.list;
      this.loading = false;
    },

    async todoNumFn() {
      let res = await getTodoNum({
        sort: "",
      });
      if (res.code === 200 && res.data && res.data.length > 0) {
        this.todoNum = res.data;
      }
    },
    goBack() {
      // this.$router.go(-1);
      // 返回上个路由栈
      const tableData = this.$store.state.formData.tableData;
      if (tableData.id) {
        this.$router.push(
          `/home?code=${this.$store.state.formData.tableData.id}`
        );
      } else {
        this.$router.push("/");
      }
    },
    getCondition() {
      console.log(this.condition);
      this.getAllTodeData();
    },
  },
};
</script>
<style lang="less" scoped>
.header {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  height: 52px;
  padding: 0 16px;
  width: 100%;
  span {
    line-height: 20px;
    font-size: 16px;
    margin-left: 6px;
    color: #525967;
    margin-right: 24px;
  }

  .photo {
    width: 34px;
    height: 34px;
    background: #107fff;
    color: #fff;
    border: 1px solid #ffffff;
    margin-left: 24px;
    font-size: 16px;
    line-height: 20px;
  }
}
.backlogPage {
  height: 100vh;
  background: #f5f7fa;
  min-width: 1000px;
}
.el-main {
  padding: 16px 0 16px 16px !important;
}

:deep(.el-form .el-input__inner) {
  height: 32px;
}

:deep(.el-form--inline .el-form-item) {
  margin-right: 20px !important;
}

:deep(.el-form-item) {
  margin-bottom: 0;
}

.data-link {
  color: #0047b3;
  cursor: pointer;
}

:deep(.el-table .el-table__cell) {
  padding: 5px 0;
}

:deep(.el-table--border::after, .el-table--group::after) {
  width: 0;
}

:deep(.el-table--border, .el-table--group) {
  border: none;
}

:deep(
    .el-table--border .el-table__cell,
    .el-table__body-wrapper
      .el-table--border.is-scrolling-left
      ~ .el-table__fixed
  ) {
  &:last-child {
    border-right: none;
  }
}

.todoNum {
  padding: 20px 25px;
  width: 290px;
  height: 112px;
  background: #ffffff;
  border-radius: 6px;
  border: 1px solid #e8eaf0;
  color: #25233a;
  cursor: pointer;
  transition: all 0.3s;
  &:hover {
    box-shadow: 0px 2px 8px 0px #a6bcf1;
    border: 1px solid #acc2f3;
  }
}
// :deep(.el-table--border .el-table__header-wrapper .el-table__cell) {
//   &:nth-last-child(2) {
//     border-right: none;
//   }
// }
.type {
  color: #1f1f1f;
  font-size: 14px;
  line-height: 20px;
  padding: 10px 42px;
  transition: all 0.3s;
  cursor: pointer;
  &.active {
    background: #f4f8fc;
    position: relative;
    &::before {
      content: " ";
      position: absolute;
      top: 0;
      left: 0;
      width: 4px;
      height: 100%;
      background: #107fff;
    }
  }
  &:hover {
    background: #f4f8fc;
  }
}

:deep(.el-range-editor.el-input__inner) {
  padding: 0 10px;
}
</style>
